<template>
    <div class="page white_bg">
        <div style="height: 46px;">
            <header class="pageHeader detailPageHeader white_bg paddingH16 paddingV8" style="line-height: 30px;">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;"
                                  @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{ title }}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">

            <personalHeader :userInfo="dataItem"/>

<!--            <div style="padding: 14px 18px 33px;" :data-userid="dataItem ? dataItem.userId : ''">-->
<!--                <div class="flexLayout" :data-userid="dataItem ? dataItem.id : ''">-->
<!--                    <div style="width: 80px;">-->
<!--                        <div class="imageArea circle hiddenOverflow" style="height: 80px; border: solid 1px #BBBBBB;">-->
<!--                            <img class="fullSpace cover" :src="dataItem.headerImg" v-if="dataItem && dataItem.headerImg"/>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="marginL16 flexItem">-->
<!--                        <div class="font12r" style="padding-top:  12px;">-->
<!--                            {{dataItem ? dataItem.userName : ''}}-->
<!--                            <span class="textLabel roleLabel alignM">代理商</span>-->
<!--                        </div>-->
<!--&lt;!&ndash;                        <div class="font14r" style="margin-top: 16px;">&ndash;&gt;-->
<!--&lt;!&ndash;                            合作截止时间：2022-xx-xx&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                        <div class="font14r marginT16">-->
<!--                            加入日期：{{ dataItem ? formatDate(dataItem.createTime) : '' }}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

            <div class="formRow paddingH16 paddingV14 font14r">
                <div class="columnName">用户账号：</div>
                <div class="columnValue">
                    <input type="text" class="inputbox block color888 font14r" style="background: #F2F3F7; "
                           placeholder="请输入用户账号（邀请码）进行产品开通" v-model="userCode"/>
                </div>
            </div>

            <van-tabs v-model="tabModule.activeIndex" sticky swipeable
                      title-inactive-color="#101010" title-active-color="#F28500"
                      line-width="0" line-height="0" style="border-top: solid 1px #BBB;" @change="onChangeTabs">
                <van-tab title="会员产品">
                    <topicCourseActivationPanel ref="activationPanel0" product-type="2" @changeProduct="onChangeProduct"/>
                </van-tab>

<!--                <van-tab title="附加产品">-->
<!--                </van-tab>-->

                <van-tab title="专题网课">
                    <topicCourseActivationPanel ref="activationPanel1" @changeProduct="onChangeProduct"/>
                </van-tab>

            </van-tabs>

            <div class="paddingH16">

                <div class="alignR font12r darkred" style="margin-top: 32px; line-height: 32px;">
                    应付比例：{{discount * 100}}%
                </div>

                <div class="marginT4 flexLayout">
                    <div class="block" style="width: 46px">
                        <input type="checkbox" id="checkAllItems" class="modernCheckbox" @change="onChangeCheckAll"/>
                    </div>
                    <div class="flexItem font14r">
                        <label for="checkAllItems">全选</label>
                    </div>
                    <div class="alignR orange" style="width: 140px;">
                        总付款金额：￥{{payAmount}}
                    </div>
                </div>

                <div class="marginT24 alignC font12r" style="line-height: 28px;">
                    <input id="agreeServiceProtocol" class="modernCheckbox" type="checkbox"
                           style="vertical-align: middle; margin: -2px 6px 0;"
                           :checked="agreeServiceProtocol" v-model="agreeServiceProtocol"/>
                    <label for="agreeServiceProtocol" style="color: hsla(219, 9%, 39%, 1)">同意</label>
                    <router-link style="color: hsla(2, 100%, 70%, 1);" :to="agreeServiceUrl">
                        《{{agreeServiceName}}》
                    </router-link>
                </div>

                <div class="marginT8">
                    <button class="button block payButton font14r" @click="submit()">立即支付{{payAmount}}元</button>
                </div>
            </div>

        </div>

        <div style="height: 51px;"></div>
    </div>
</template>

<script>
import {Tab, Tabs} from 'vant';
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import topicCourseActivationPanel from "./modules/topicCourseActivationPanel";
import personalHeader from "./personalHeader";

// config and data
import appConfig from "@/appConfig";
import distributionApi from '@/api/distribution';

// util
import appHelper    from '@/util/appHelper';
import userUtil     from "../shixunApp/userUtil";
import timerManager from "@comp/platformApi/timerManager";
import consoleApi   from "@comp/platformApi/consoleApi";

const config = {
    apiConfig: {
        get: {
            url: 'portal/v2/distribution/agency/get/info',
            dataPath : 'data'
        }
    },
    agreeServiceName : '师讯代理商产品开通服务协议',
    agreeServiceUrl : '/help/agreement/AGENCY_OPEN_COURSE_AGREEMENT',
};

export default {
    name: "agencyProductActivation",
    extends: shixunPagePart,
    components: {
        'van-tab': Tab,
        'van-tabs': Tabs,
        personalHeader,
        topicCourseActivationPanel
    },
    data() {
        return {
            title: '代理商个人中心',
            apiConfig: config.apiConfig,
            enableDataList: true,
            enableDataItem: true,
            tabModule: {
                activeIndex: 0
            },

            vipDueTime : '',
            userCode : '',

            agreeServiceProtocol : false,
            agreeServiceUrl     : config.agreeServiceUrl,
            agreeServiceName    : config.agreeServiceName,

            discount : 0,
            payAmount : 0,
            totalAmount : 0,
            needRecharge : false,

            checkedIds : []
        }
    },
    methods: {
        back: function () {
            appHelper.goToPage('agencyPersonalCenter');
        },
        onChangeProduct(ids) {
            this.checkedIds = ids;
            consoleApi.log('checkedIds: ' + this.checkedIds.join(','));
            if (this.checkedIds.length)
            {
                distributionApi.calculateAgencyProductPrice(ids, (result) => {
                    this.discount = result.data.discount;
                    this.payAmount = result.data.payAmount;
                    this.totalAmount = result.data.totalAmount;
                    this.needRecharge = result.data.needRecharge;
                    consoleApi.log('[agency product activation] 是否需要充值：' + (this.needRecharge ? '是' : '否'));
                });
            }
            else {
                this.discount = 0;
                this.payAmount = 0;
                this.totalAmount = 0;
                this.needRecharge = 0;
            }

        },
        onChangeTabs(name, title) {
            this.discount = this.payAmount = this.totalAmount = this.needRecharge = 0;
        },
        onChangeCheckAll(event) {

            // if(event.currentTarget.checked)
            // {
            //     consoleApi.log('check all');
            // }
            // else
            // {
            //     consoleApi.log('uncheck all');
            // }

            let checked = event.currentTarget.checked;

            switch (this.tabModule.activeIndex)
            {
                case 0:
                    this.$refs.activationPanel0.checkAll(checked);
                    break;
                case 1:
                    this.$refs.activationPanel1.checkAll(checked);
                    break;

            }
        },
        submit() {
            if (!this.agreeServiceProtocol)
            {
                appHelper.showHint('请先阅读并同意协议');
                return;
            }
            if (this.needRecharge)
            {
                appHelper.showHint('余额不足，请先充值。');
                timerManager.setTimeout(() => {
                    appHelper.goToPage('agencyRecharge');
                }, 2 * 1000);
                return;
            }
            if (!this.userCode)
            {
                appHelper.showHint('请填写用户账号');
                return;
            }

            appHelper.confirm({
                title : '开通产品',
                content : '确定支付并为' + this.userCode + '用户开通产品吗？',
                okText : '是',
                cancelText : '否'
            }, (status) => {
                if (!status)
                {
                    return;
                }

                distributionApi.payAgencyProduct(this.userCode, this.checkedIds, (result) => {
                    if (result.errorCode)
                    {
                        appHelper.showHint(result.msg, {type : 'error'});
                        return;
                    }
                    appHelper.showHint('开通成功！');
                });
            });
        }
    },
    mounted() {

        const me = this;

        this.loadDataItem();

        appHelper.needLogin((user) => {
            me.userInstance = userUtil.createUser(user);
            me.vipDueTime = user.vipDueTime['4'];
        });
    }
}
</script>

<style lang="scss" scoped>
.orange {
    color: #F28500;
}

.tabModule {
    .tabItem {
        padding: 13px 0 10px;
        color: #8994A9;

        &.active {
            color: #FFA724;

            &:before {
                content: '';
                display: block;
                position: absolute;
                width: 19px;
                height: 2px;
                left: 50%;
                margin-left: -9px;
                bottom: 4px;
                background: #FFA724;
                border-radius: 2px;
            }
        }
    }
}

.vipIcon {
    width: 32px;
    height: 14px;
    background-image: url('data:image/png;base64,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');
}
.roleLabel {
    padding: 0 8px;
    height: 27px;
    line-height: 27px;
    font-size: 14px;
    text-align: center;
    background: transparent;
    border: solid 1px #BBBBBB;
    color: #101010;
}
.orangeButton {
    background: #F7AA01;
    color: white;
    height: 40px;
    line-height: 40px;
    border-radius: 16px;
}

.formRow {
    display: flex;
    .columnName {
        color: #5B616C;
        width: 70px;
    }
    .columnValue {
        flex: 1;
        .inputbox {
            display: block;
            width: 100%;
            height: 27px;
            line-height: 27px;
            border: none;
            background: transparent;
            color: hsla(0, 0%, 20%, 1);
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
    }
}
.payButton {
    background: #E99D42;
    border : none 0;
    padding: 0;
    height: 39px;
    line-height: 39px;
    border-radius: 25px;
    color: white;
}
</style>
